// @ts-ignore
import mixpanel from "mixpanel-browser";
import { EventName } from "./event_names";

export type AnalyticsUser = {
    id?: string;
    uuid?: string;
    email?: string;
    name?: string;
    [key: string]: any;
};

let isInitialized = false;
let isEnabled = false;

export const initMixpanelClient = () => {
    if (isInitialized) {
        return;
    }

    const projectToken = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;
    if (!projectToken) {
        return;
    }

    mixpanel.init(projectToken, {
        debug: process.env.NODE_ENV !== "production",
        track_pageview: true,
        persistence: "localStorage",
        persistence_name: "mp_mixpanel",
        record_sessions_percent: 1,
        ignore_dnt: true,
    });
    mixpanel.clear_opt_in_out_tracking();
    isInitialized = true;
    isEnabled = true;
};

export const identifyMixpanelUser = (user: AnalyticsUser) => {
    initMixpanelClient();
    if (!isEnabled) {
        return;
    }

    const distinctId = user.uuid || user.id;
    if (!distinctId) {
        return;
    }

    mixpanel.identify(distinctId);
    mixpanel.people.set({
        $email: user.email,
        $is_premium: user.is_premium,
        $plan_type: user.plan_type,
        $first_name: user.first_name,
        $last_name: user.last_name,
        $created: user.created_at || user.createdAt,
        $last_login: new Date(),
    });
};

export const trackMixpanelEvent = (
    name: EventName,
    properties: Record<string, any> = {}
) => {
    initMixpanelClient();
    if (!isEnabled) {
        return;
    }

    mixpanel.track(name, properties);
};

export const resetMixpanelUser = () => {
    if (!isEnabled) {
        return;
    }

    mixpanel.reset();
};
